import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {RecoilRoot} from "recoil";
import {router} from './router';
import {
    initAnalytics,
    routePatternFrom,
    trackEvent,
    trackPageView,
} from './helpers/analytics';
import "tw-elements-react/dist/css/tw-elements-react.min.css";
// Nạp cuối cùng: tw-elements kèm một bản preflight Tailwind riêng, phải để
// design system của Biadi ghi đè lên nó (viền, màu nền, typography).
import 'statics/css/index.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);


root.render(
    <RecoilRoot>
            <App/>
    </RecoilRoot>
);

// ── Google Analytics 4 ───────────────────────────────────────────────
// Không có REACT_APP_GA4_ID thì mọi hàm dưới đây đều là no-op.
initAnalytics();

// SPA: gtag chỉ tự bắn page_view lúc tải trang đầu tiên, nên phải tự gửi
// cho mỗi lần chuyển route. Dùng router.subscribe để không phải sửa từng
// trang, và gửi *mẫu* route để báo cáo không vỡ vụn theo id.
let lastPattern = '';
const sendCurrentPageView = (matches?: any[]) => {
    const pattern = routePatternFrom(matches);
    if (pattern === lastPattern) return;
    lastPattern = pattern;
    // Mỗi trang đặt document.title trong useEffect của chính nó. Gửi ngay
    // lập tức sẽ lấy nhầm tiêu đề của trang trước (đã kiểm chứng), nên đợi
    // sau khi React vẽ xong rồi mới gửi.
    requestAnimationFrame(() => setTimeout(() => trackPageView(pattern), 300));
};

sendCurrentPageView(router.state.matches as any[]);
router.subscribe((state) => {
    if (state.navigation.state === 'idle') {
        sendCurrentPageView(state.matches as any[]);
    }
});

// Chỉ số hiệu năng thật của người dùng, gửi theo quy ước web_vitals của GA4.
reportWebVitals(({name, delta, id}) => {
    trackEvent('web_vitals', {
        metric_name: name,
        // CLS là số thập phân rất nhỏ, GA4 chỉ nhận số nguyên cho metric.
        value: Math.round(name === 'CLS' ? delta * 1000 : delta),
        metric_id: id,
    });
});
